import { TechDocPage, TechDocWizardPage } from '../containers/pages';
import { PRODUCT_ID_BAAS, ALLETRAMP_VIDEO_URL } from '../constants';
import { powerupInit } from './alletraMPPagesConfigCommon';
import { gettingStarted } from './alletraMPPagesConfigComm';

const physicalInstallPath = '/physical-install/';
const factoryCablePath = `${physicalInstallPath}cable/`;
const factoryUnboxPath = `${physicalInstallPath}unbox/`;

export const pagesConfig = [
  ...gettingStarted(PRODUCT_ID_BAAS),
  {
    path: physicalInstallPath,
    menuText: 'physicalInstallation',
    exact: true,
    redirectTo: factoryUnboxPath,
    submenuItems: [
      {
        path: factoryUnboxPath,
        menuText: 'unbox',
        exact: true,
        redirectTo: `${factoryUnboxPath}1`,
      },
      {
        path: `${factoryUnboxPath}:step`,
        exact: true,
        component: TechDocWizardPage,
        pageName: 'unbox',
        pageProps: {
          steps: [
            {
              videoUrl: ALLETRAMP_VIDEO_URL.FACTORY_UNBOX_STEP1,
              steptitle: 'Unbox Array',
            },
            {
              videoUrl: ALLETRAMP_VIDEO_URL.FACTORY_UNBOX_STEP2,
              steptitle: 'Remove Array From Pallet',
            },
            {
              videoUrl: ALLETRAMP_VIDEO_URL.FACTORY_UNBOX_STEP3,
              steptitle: 'Stabilize the Rack',
            },
          ],
        },
      },
      {
        path: factoryCablePath,
        menuText: 'cableSwitched',
        exact: true,
        redirectTo: `${factoryCablePath}1`,
      },
      {
        path: `${factoryCablePath}:step`,
        exact: true,
        component: TechDocWizardPage,
        pageName: 'cableSwitched',
        pageProps: {
          steps: [
            {
              videoUrl: ALLETRAMP_VIDEO_URL.FIELD_CABLE_STEP1,
              steptitle: 'Cable Admin Ports',
            },
            {
              steptitle: 'Cable CDMs',
            },
            {
              videoUrl: ALLETRAMP_VIDEO_URL.FIELD_CABLE_SWITCHED_STEP2,
              steptitle: 'Cable Data Ports',
            },
            {
              videoUrl: ALLETRAMP_VIDEO_URL.FIELD_CABLE_STEP3,
              steptitle: 'Cable Hosts',
            },
            {
              videoUrl: ALLETRAMP_VIDEO_URL.FIELD_CABLE_STEP4,
              steptitle: 'Cable Power Supplies',
            },
          ],
        },
      },
      {
        path: `${physicalInstallPath}powerOn`,
        menuText: 'powerOn',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRAMP_VIDEO_URL.POWERUPANDINIT,
        },
      },
    ],
  },
  ...powerupInit,
];
